import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import AddTerminalFilesForm from "../../components/AddTerminalFilesForm/AddTerminalFilesForm";
import Layout from "../../components/shared/Layout/Layout";

const AddTerminalFilePage = ({ grades, getGradeList }) => {
  useEffect(() => {
    getGradeList();
  }, []);
  return (
    <div className="bg_light">
      <Layout title={`Terminal Assessment`}>
        <AddTerminalFilesForm grades={grades} />
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(AddTerminalFilePage);
